import React, { useContext, useEffect, useState } from 'react'
import { Box, Text, Select, Sidebar, Nav } from "grommet"
import styled from 'styled-components'

import { PowerForceShutdown, Power, PowerCycle, StackOverflow, Actions, FormDown } from 'grommet-icons'

import UserContext from '../../../context/UserContext'
import {
    ActionPanelTTService, ActionPanelDrain, ActionPanelUnDrain,
    ActionPanelOCDrain, ActionPanelOCUnDrain, ActionPanelOCTTUS,
    ActionPanelBouncerRefreshDiag, ActionPanelOCRefreshDiag,
    ActionPanelOCRebalance, ActionPanelPSEvacuate, ActionPanelBouncerClearPending, ActionPanelFIXDrain,
    ActionPanelPSBeaconOff
} from './HealthStatusServiceHostActionsPanels'

import { gql, useQuery } from '@apollo/client';
import { useToasts } from 'react-toast-notifications'
import { useHaProxyGroup } from '../../../utils/haproxy'
import { TTInputSelectExternal } from '../../common/TTForm'
import { usePSNodeType } from '../../../utils/psNodeType'
import { getFromMapOrDefault } from '../../../utils/mapHandler'


const BoxScrollbar = styled(Box)`
    /* width */
    ::-webkit-scrollbar {
        width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
    background: brand; 
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
    background: #EDEDED; 
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
    background: #777; 
    }
`

const TTServicesSelect = styled(Select)`
    width: auto,
    height: 25px
`;

const TTService = ({ host, token, env, addToast }) => {

    const SERVICE_QUERY = gql`
    query MyQuery($nodeName: String!) {
    serviceGroup_node(where: {node: {name: {_eq: $nodeName}}}) {
        installed_debesys_applications: chef(path: "installed_debesys_applications")
    }
    }
    `

    // Get TT Services
    const ttservicesNode = useQuery(
        SERVICE_QUERY,
        { variables: { nodeName: host } }
    )

    const [options, setoptions] = useState([])

    useEffect(() => {

        const whiteListedServices = new Set(['sentinelone', 'stunnel']);

        let options_temp = []
        if (!ttservicesNode.loading && ttservicesNode.data &&
            ttservicesNode.data.serviceGroup_node &&
            ttservicesNode.data.serviceGroup_node.length > 0 &&
            ttservicesNode.data.serviceGroup_node[0] &&
            ttservicesNode.data.serviceGroup_node[0].installed_debesys_applications
        ) {
            Object.keys(ttservicesNode.data.serviceGroup_node[0].installed_debesys_applications).forEach(app => {
                const services = ttservicesNode.data.serviceGroup_node[0].installed_debesys_applications[app].service_names ? ttservicesNode.data.serviceGroup_node[0].installed_debesys_applications[app].service_names : []
                options_temp = options_temp.concat(services)
            });
        }

        const difference = options_temp.filter(x => !whiteListedServices.has(x))
        setoptions(difference)

    }, [ttservicesNode.loading, ttservicesNode.data])

    const [svcDisabled, setSvcDisabled] = useState(true)
    const [service_name, setService_name] = useState("")

    useEffect(() => {
        // if only 1 service set value to the option
        if (options.length === 1) {
            setService_name(options[0])
            setSvcDisabled(false)
        }
    }, [options])

    return (
        <Box>
            <Box width="200px" pad="none" margin={{ top: "10px" }}>
                <TTServicesSelect
                    id="service_name"
                    name="service_name"
                    placeholder="Service Name"
                    value={service_name}
                    options={options}
                    dropHeight="small"
                    size="xsmall"
                    onChange={({ option }) => {
                        setService_name(option)
                        if (svcDisabled) {
                            setSvcDisabled(false)
                        }
                    }}
                    valueLabel={
                        <Box
                            width="small"
                            round="small"
                            overflow="hidden"
                            align="start"
                            margin={{ left: "10px" }}
                        >
                            <Text size="11px" weight="bold">{service_name || "Service Name"}</Text>
                        </Box>
                    }
                    icon={
                        <Box>
                            <FormDown color="brand" />
                        </Box>
                    }
                >

                    {(option, index) => (
                        <Box margin={{ top: "15px", bottom: "15px", left: "10px" }}>
                            <Text size="11px" weight="bold">{option}</Text>
                        </Box>
                    )}

                </TTServicesSelect>
            </Box>

            <Box direction="column" pad="none" margin={{ top: "10px" }}>
                <ActionPanelTTService disabled={svcDisabled} icon={<PowerCycle size="16px" color="ttdown" />} appName="ttservice_actions" method="POST" commandName="restart" host={host} label="Restart" service_name={service_name} env={env} token={token} addToast={addToast} />
                <ActionPanelTTService disabled={svcDisabled} icon={<Power size="16px" color="ttok" />} appName="ttservice_actions" method="POST" commandName="start" host={host} label="Start" service_name={service_name} env={env} token={token} addToast={addToast} />
                <ActionPanelTTService disabled={svcDisabled} icon={<PowerForceShutdown size="16px" color="ttdown" />} appName="ttservice_actions" method="POST" commandName="stop" host={host} label="Stop" service_name={service_name} env={env} token={token} addToast={addToast} />
                <ActionPanelTTService disabled={svcDisabled} icon={<StackOverflow size="16px" color="ttwarning" />} appName="ttservice_actions" method="GET" commandName="gstack" host={host} label="Gstack" service_name={service_name} env={env} token={token} addToast={addToast} />
                <ActionPanelTTService disabled={svcDisabled} icon={<Actions size="16px" color="ttdown" />} appName="ttservice_actions" method="GET" commandName="core" host={host} label="Core" service_name={service_name} env={env} token={token} addToast={addToast} />
            </Box>
        </Box>
    )
}

const TTHAProxy = ({ host, token, env, addToast }) => {
    const haproxyGroups = useHaProxyGroup(host)
    const [backend, setbackend] = useState("")
    return (
        <Box direction="column" pad="none">
            {haproxyGroups && haproxyGroups[host] && haproxyGroups[host].length === 1 &&
                <>
                    <ActionPanelDrain appName="haproxy" commandName="mode" host={host} label="Drain" env={env} token={token} addToast={addToast} />
                    <ActionPanelUnDrain appName="haproxy" commandName="mode" host={host} label="UnDrain" env={env} token={token} addToast={addToast} />
                </>
            }
            {haproxyGroups && haproxyGroups[host] && haproxyGroups[host].length > 1 &&
                <>
                    <TTInputSelectExternal name={'haproxy groups'} label={'Group'} defaultOptions={[...new Set(haproxyGroups[host])]} setExternal={setbackend} />
                    {backend &&
                        <>
                            <ActionPanelDrain appName="haproxy" commandName="mode" host={host} label={"Drain"} env={env} token={token} addToast={addToast} backend={backend} />
                            <ActionPanelUnDrain appName="haproxy" commandName="mode" host={host} label="UnDrain" env={env} token={token} addToast={addToast} backend={backend} />
                        </>
                    }
                </>
            }
        </Box>
    )
}

const OC = ({ host, token, env, addToast, serviceGroupName, zkData }) => {

    const [exchangeName, setexchangeName] = useState(false)

    useEffect(() => {
        if (zkData && zkData.service_name) {
            if (serviceGroupName !== 'OC') {
                setexchangeName("BANK_ALGO")

            } else {
                const serviceNameExchangeMap = {
                    "asx_ntp": "asx",
                    "cfe_bats": "cfe",
                    "cme_sbe": "cme",
                    "cme_sbe_btec": "cme_btec",
                    "coinflex": "coinfloorex",
                    "eex_derivative": "eex",
                    "eurex_fx": "eurex",

                    // Mapping Prime ASE
                    "bvmf_ase": "bvmf",
                    "bvmf_sbe_ase": "bvmf",
                    "bvmf_sbe": "bvmf",
                    "cme_ase": "cme",
                    "cme_sbe_ase": "cme",
                    "eurex_ase": "eurex",
                    "ice_ase": "ice",
                    "ice_l_ase": "ice_l",
                    "sgx_ase": "sgx",
                }

                setexchangeName(getFromMapOrDefault(serviceNameExchangeMap, zkData.service_name, zkData.service_name));
            }
        }
    }, [serviceGroupName, zkData])

    return (
        <Box direction="column" pad="none">
            {zkData && exchangeName &&
                <>
                    <ActionPanelOCDrain appName="oc" commandName="drain" host={host} label="Drain" env={env} token={token} addToast={addToast} clusterName={exchangeName} />
                    <ActionPanelOCUnDrain appName="oc" commandName="drain" host={host} label="UnDrain" env={env} token={token} addToast={addToast} clusterName={exchangeName} />
                    {serviceGroupName === 'OC' && <ActionPanelOCRebalance appName="oc" commandName="rebalance" host={host} label="Rebalance Connections" env={env} token={token} addToast={addToast} market={exchangeName.toUpperCase()} />}
                </>
            }
            <ActionPanelOCTTUS appName="oc" commandName="refresh_ttus_cache" host={host} label="Refresh TTUS Cache" env={env} token={token} addToast={addToast} />
            <ActionPanelOCRefreshDiag appName="diagnostics" commandName="oc" host={host} label="Force Run Diagnostics Check" env={env} token={token} addToast={addToast} />
        </Box>
    )
}

const Bouncer = ({ host, token, env, addToast }) => {
    return (
        <Box direction="column" pad="none">
            <ActionPanelBouncerRefreshDiag appName="diagnostics" commandName="bouncer" host={host} label="Force Run Diagnostics Check" env={env} token={token} addToast={addToast} />
            <ActionPanelBouncerClearPending appName="bouncer" commandName="clear_pending_orders" host={host} label="Clear Pending Orders" env={env} token={token} addToast={addToast} />
        </Box>
    )
}

const PriceServer = ({ host, token, env, addToast, zkData, instanceId }) => {
    const psLabelLookup = usePSNodeType(env)
    const isDr = psLabelLookup && psLabelLookup[host] && psLabelLookup[host]["mode"] && psLabelLookup[host]["mode"] === 'DR(2)' ? true : false
    const serviceName = zkData && zkData.service_name
    return (
        <Box direction="column" pad="none">
            <ActionPanelPSEvacuate appName="price_server" commandName="failover_beacon" instanceId={instanceId} label="Drain & Evacuate Price Clients" env={env} token={token} addToast={addToast} />
            {!isDr && <ActionPanelPSBeaconOff serviceName={serviceName} appName="price_server" commandName="failover" instanceId={instanceId} label={"Beacon Off"} env={env} token={token} addToast={addToast} />}
        </Box>
    )
}

const MDS = ({ host, token, env, addToast, zkData, instanceId }) => {
    const psLabelLookup = usePSNodeType(env)
    const isDr = psLabelLookup && psLabelLookup[host] && psLabelLookup[host]["mode"] && psLabelLookup[host]["mode"] === 'DR(2)' ? true : false
    const serviceName = zkData && zkData.service_name
    return (
        <Box direction="column" pad="none">
            <ActionPanelPSEvacuate appName="mds" commandName="failover_beacon" instanceId={instanceId} label="Drain & Evacuate Price Clients" env={env} token={token} addToast={addToast} />
            {!isDr && <ActionPanelPSBeaconOff serviceName={serviceName} appName="mds" commandName="failover_beacon" instanceId={instanceId} label={"Beacon Off"} env={env} token={token} addToast={addToast} />}
        </Box>
    )
}

const FIXDrain = ({ token, env, addToast, instanceId }) => {
    return (
        <Box direction="column" pad="none">
            <ActionPanelFIXDrain appName="fix" commandName="prevent_new_connection" instanceId={instanceId} label="Drain" env={env} token={token} addToast={addToast} prevent_new_connection={true} session_type="fixorderrouting" />
        </Box>
    )
}

const FIXUnDrain = ({ token, env, addToast, instanceId }) => {
    return (
        <Box direction="column" pad="none">
            <ActionPanelFIXDrain appName="fix" commandName="prevent_new_connection" instanceId={instanceId} label="UnDrain" env={env} token={token} addToast={addToast} prevent_new_connection={false} session_type="fixorderrouting" />
        </Box>
    )
}

const HealthStatusServiceHostActions = ({
    instanceId,
    host,
    env,
    behindHA,
    serviceGroupName = "",
    zkData = ""
}) => {

    // START REQUIRED FOR PANEL

    const { addToast } = useToasts()
    const [showAdmin, setShowAdmin] = useState(false)
    const token = useContext(UserContext)

    // END REQUIRED FOR PANEL

    useEffect(() => {
        if (process.env.REACT_APP_ENVIRONMENT === "ext-lite") {
            setShowAdmin(false)
        }
        else if (token.scopes.includes("triage/ad")) {
            setShowAdmin(true)
        } else {
            setShowAdmin(false)
        }
    }, [token.scopes])

    if (showAdmin === false) {
        return null
    } else {
        return (
            <BoxScrollbar overflow={{ horizontal: 'hidden', vertical: 'auto' }} height={{ max: "500px" }} >
                <Sidebar round="small">
                    <Nav gap="small">
                        {behindHA &&
                            <>
                                <Text size="small" weight="bold">HAProxy</Text>
                                <TTHAProxy host={host} token={token} env={env} addToast={addToast} />
                            </>
                        }
                        {(serviceGroupName === "OC" || serviceGroupName === "FIX Order Gateway") &&
                            <>
                                <Text size="small" weight="bold">{serviceGroupName}</Text>
                                <OC serviceGroupName={serviceGroupName} host={host} token={token} env={env} addToast={addToast} zkData={zkData} />
                            </>
                        }
                        {serviceGroupName === "Bouncer" &&
                            <>
                                <Text size="small" weight="bold">{serviceGroupName}</Text>
                                <Bouncer host={host} token={token} env={env} addToast={addToast} />
                            </>
                        }
                        {serviceGroupName === "PriceServer" &&
                            <>
                                <Text size="small" weight="bold">{serviceGroupName}</Text>
                                <PriceServer host={host} token={token} env={env} addToast={addToast} zkData={zkData} instanceId={instanceId} />
                            </>
                        }
                        {serviceGroupName === "MDS Adapter" &&
                            <>
                                <Text size="small" weight="bold">MDS</Text>
                                <MDS host={host} token={token} env={env} addToast={addToast} zkData={zkData} instanceId={instanceId} />
                            </>
                        }
                        {serviceGroupName === 'FIX Order Routing' && !behindHA &&
                            <>
                                <Text size="small" weight="bold">FIX Order Routing</Text>
                                <FIXDrain token={token} env={env} addToast={addToast} instanceId={instanceId} />
                                <FIXUnDrain token={token} env={env} addToast={addToast} instanceId={instanceId} />
                            </>
                        }
                        {env.split("-")[0] === "ext" &&
                            <>
                                <Text size="small" weight="bold">TTServices</Text>
                                <TTService host={host} token={token} env={env} addToast={addToast} />
                            </>
                        }
                    </Nav>
                </Sidebar>
            </BoxScrollbar>
        )
    }

}

export default HealthStatusServiceHostActions
